import React from 'react';

// Reusable sortable column header for admin tables.
// Click toggles direction on same key, switches key on different one.
// Used by: AdminProfilesPage, AdminUsersPage, AdminCommunityPage, BookingsTable.
// Accepts an optional `style` prop for extra styling (width, sticky position, background, etc.).

export default function SortableHeader({ label, sortKey, currentKey, currentDir, onSort, align, style }) {
  const active = sortKey === currentKey;
  const arrow = active ? (currentDir === 'desc' ? ' ↓' : ' ↑') : '';
  return (
    <th
      onClick={() => onSort(sortKey)}
      style={{
        padding: '8px 10px',
        cursor: 'pointer',
        userSelect: 'none',
        textAlign: align || 'left',
        color: active ? 'var(--primary)' : 'inherit',
        whiteSpace: 'nowrap',
        ...style,
      }}
      title="클릭하여 정렬"
    >
      {label}{arrow}
    </th>
  );
}
